import React from 'react';

type TProps = {
  active: boolean;
  children: React.ReactNode;
};

export function Liferay({ children, active }: TProps) {
  return active ? <div className="smls-lf">{children}</div> : <>{children}</>;
}
